import { DatePipe, NgFor, NgIf, AsyncPipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { firstValueFrom, ReplaySubject } from 'rxjs';
import { GestionclientesService } from 'src/app/clientes/gestionclientes.service';
import { EmpleadoService } from 'src/app/empleado/empleado.service';
import { Cliente } from 'src/app/shared/model/ajustesUsuario/cliente.model';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Empleado } from 'src/app/shared/model/empleado/empleado.model';
import { Puesto } from 'src/app/shared/model/empleado/puesto.model';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import { Persona } from 'src/app/shared/model/security/persona.model';
import { Usuario } from 'src/app/shared/model/security/usuario.model';
import { GenericoService } from 'src/app/shared/services/generico.service';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { SweetAlertComponent } from 'src/app/shared/SweetMesssage';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { ProyectosService } from 'src/app/proyectos/proyectos.service';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatOption } from '@angular/material/autocomplete';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-reporte-hr-trabajadas',
    templateUrl: './reporte-hr-trabajadas.component.html',
    styleUrls: ['./reporte-hr-trabajadas.component.css'],
    imports: [MatFormField, MatSelect, FormsModule, NgxMatSelectSearchModule, ReactiveFormsModule, NgFor, MatOption, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatIcon, MatButton, NgIf, AsyncPipe, NgxPaginationModule]
})
export class ReporteHrTrabajadasComponent implements OnInit {
  // Variable para fecha maxima
  maxDate: Date;
  minDate: Date;

  maxDateProy: Date;
  minDateProy: Date;

  @ViewChild('downloadReporteExcell') private downloadReporteExcell: ElementRef;

  modelProyecto: any;
  modelClienteProyecto: any;
  modelColaboradorProyecto: any;
  modelFechaInicioProy: any;
  modelFechaFinProy: any;
  consultaProyecto: ConsultaList<Proyecto>;
  totalRegistros: number;
  currentPageReporteProyecto = 1;
  readonly pageSize = 10;
  public labels: { previousLabel: string; nextLabel: string } = {
    previousLabel: 'ANTERIOR',
    nextLabel: 'SIGUIENTE'
  };

  // Variable para definicion de dias (Lunes/Viernes).
  fechaLunes: Date;
  fechaViernes: Date;
  // -- Id para reporte por proyecto.
  idProyecto: string;
  idClienteProyecto: number = null;
  idColaboladorProyecto: number = null;
  nombreColaborador: string;
  // Lista tipo proyecto.
  proyectosReport: Proyecto[];
  listaProyectoGrid: any[];
  // Request para lista clientes
  requestCliente = new ConsultaList<Cliente>();
  listaClientes: Array<Cliente>;
  proyecto = new FormControl();
  cliente = new FormControl();
  colaborador = new FormControl();
  empleadosReportProyecto: Empleado[];
  fechaInicio = new Date();
  fechaFin = new Date();
  fechaMax= new Date();

  public filterCliente: ReplaySubject<Cliente[]> = new ReplaySubject<Cliente[]>(1);
  public filterProyecto: ReplaySubject<Proyecto[]> = new ReplaySubject<Proyecto[]>(1);
  public filterProyectoEmpleado: ReplaySubject<Empleado[]> = new ReplaySubject<Empleado[]>(1);

  requestEmpleados;
  // Valor inicial de Página Cliente
  regPagCliente = 1000;
  // Lista de empleados.
  empleadosReport: Empleado[];
  empleados: Empleado[];
  requestFilter = new ConsultaList<Proyecto>();

  ahora: any; 


  constructor(private datePipe: DatePipe, private genService: GenericoService, private msg: Msg, private proyectosService: ProyectosService,
    private empleadosService: EmpleadoService, private clientService: GestionclientesService, private sweetAlert: SweetAlertComponent) { }

  ngOnInit() {
    // Fechas semanal
    var curr = new Date();
    this.maxDate = new Date(curr.setDate(curr.getDate() - curr.getDay() + 5));
    this.minDate = new Date();

    
		const datePite = new DatePipe('en-Es')
		this.ahora = datePite.transform(new Date(), 'yyyy-MM-dd')
    // Asiganción de valores 
    this.requestCliente.regInicial = 0;
    this.requestCliente.regXPagina = this.regPagCliente;
    this.cliente.valueChanges.subscribe(() => { this.filtraCliente() });
    this.proyecto.valueChanges.subscribe(() => { this.filtraProyecto() });
    this.colaborador.valueChanges.subscribe(() => { this.filtraEmpleado() });

    this.consultarEmpleados();
    this.consultarClientes();
    this.consultaFechaSemanal();
    this.consultaProyectosActivos();
    this.consultaPaginaReporteProyecto(1);
  }
  consultaFechaSemanal() {
    var dateActual = new Date();
    this.fechaLunes = new Date(dateActual.setDate(dateActual.getDate() - dateActual.getDay() + 1));
    this.fechaViernes = new Date(dateActual.setDate(dateActual.getDate() - dateActual.getDay() + 5));
  }
  consultaProyectosActivos(){
    this.requestFilter.param6 = 3;
    this.requestFilter.regXPagina = Constantes.DIEZ;
  
    this.proyectosService.consultaProyectoMongo(this.requestFilter).subscribe((response: any) => {
      this.proyectosReport = response.content;
      this.filterProyecto.next(this.proyectosReport.slice());  
    });

  }
  consultarClientes(): void {
    this.clientService.filtroBusquedaCliente(this.requestCliente).subscribe(res => {
      if (res.pCodRetorno === '00000') {
        this.listaClientes = res.list;
        this.filterCliente.next(this.listaClientes.slice());
      } else {
        this.listaClientes = new Array<Cliente>();
      }
    });
  }

  consultarEmpleados(): void {
   
    this.requestEmpleados = new ConsultaList<Empleado>();
    this.requestEmpleados.regXPagina = 10000;
    this.requestEmpleados.regInicial = 0;
    this.requestEmpleados.bean = new Empleado();
    this.requestEmpleados.bean.usuario = new Usuario();
    this.requestEmpleados.bean.persona = new Persona();
    this.requestEmpleados.bean.puesto = new Puesto();
    firstValueFrom(this.empleadosService.consultaEmpleados(this.requestEmpleados)).then(res => {
      
      if (res.list.length !== 0) {
        this.empleados = res.list;
        this.empleadosReportProyecto = res.list;
        this.filterProyectoEmpleado.next(this.empleadosReportProyecto.slice());
      }
    }).catch(error => {
   
      this.msg.errorCall("No se pudo consultar los empleados", null, null);
    });
  }

  consultaListaSemanalProy() {
    this.maxDateProy = this.modelFechaFinProy !== '' ? new Date(this.modelFechaFinProy) : new Date();
    this.minDateProy = this.modelFechaInicioProy !== '' ? new Date(this.modelFechaInicioProy) : new Date();
  }

  consultaPaginaReporteProyecto(page: number): void {
    this.currentPageReporteProyecto = page;
    let fecha_ini;
    let fecha_fin;
    if (!this.modelFechaInicioProy || !this.modelFechaFinProy) {
      fecha_ini = this.datePipe.transform(this.fechaLunes, 'yyyy-MM-dd');
      fecha_fin = this.datePipe.transform(this.fechaViernes, 'yyyy-MM-dd');
    } else {
      fecha_ini = this.datePipe.transform(this.modelFechaInicioProy, 'yyyy-MM-dd').toString();
      fecha_fin = this.datePipe.transform(this.modelFechaFinProy, 'yyyy-MM-dd').toString();
    }
    const regInicial = (page - 1) * this.pageSize;
    const paginaActual = page - 1;
    this.consultaProyecto = new ConsultaList<Proyecto>();
    this.consultaProyecto.param1 = this.idProyecto;
    this.consultaProyecto.param6 = this.idColaboladorProyecto;
    this.consultaProyecto.param7 = fecha_ini;
    this.consultaProyecto.param8 = fecha_fin;
    this.consultaProyecto.regInicial = regInicial;
    this.consultaProyecto.regFinal = this.pageSize;
    this.consultaProyecto.pagina = paginaActual;
    this.genService.reporteEmpleadoProyecto(this.consultaProyecto, 'reporteByProyecto.do').subscribe((response:any) => {
        this.totalRegistros = this.resolveTotalRegistros(response);
        this.listaProyectoGrid = Array.isArray(response?.content) ? response.content : [];

        const maxPages = this.totalPagesReporteProyecto;
        if (maxPages > 0 && this.currentPageReporteProyecto > maxPages) {
          this.consultaPaginaReporteProyecto(maxPages);
        }
    }, error => {
      console.log("Error " + error);
     
    });
  }

  descargarReporteByProyecto() {
    let fecha_ini;
    let fecha_fin;
    if (!this.modelFechaInicioProy || !this.modelFechaFinProy) {
      fecha_ini = this.datePipe.transform(this.fechaLunes, 'yyyy-MM-dd');
      fecha_fin = this.datePipe.transform(this.fechaViernes, 'yyyy-MM-dd');
    } else {
      fecha_ini = this.datePipe.transform(this.modelFechaInicioProy, 'yyyy-MM-dd').toString();
      fecha_fin = this.datePipe.transform(this.modelFechaFinProy, 'yyyy-MM-dd').toString();
    }

    this.genService.descargarReporteByProyecto('reporteByProyecto.do', this.idProyecto, this.idColaboladorProyecto, fecha_ini, fecha_fin).subscribe(response => {
 
      const blob = new Blob([response],
        {
          type: 'application/' + "x-download"
        }
      );
      const fileUrl = window.URL.createObjectURL(blob);
      const link = this.downloadReporteExcell.nativeElement;
      if(this.listaProyectoGrid.length >= 1){
      link.href = fileUrl;
      link.download = "ReporteProyecto " + fecha_ini + "-" + fecha_fin + ".xlsx";
      link.click();
      window.URL.revokeObjectURL(fileUrl);
    }else {
      this.sweetAlert.showSwal('error-message-msg', Constantes.SIN_REGISTROS);
     
    }
    }, error => {
      
    });
  }

  filtraCliente() {
    if (!this.listaClientes) { return; }
    let search = this.cliente.value;
    if (!search) {
      this.filterCliente.next(this.listaClientes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterCliente.next(
      this.listaClientes.filter(cliente => cliente.razonsocial.toLowerCase().indexOf(search) > -1)
    );
  }

  filtraProyecto() {
    if (!this.proyectosReport) { return; }
    let search = this.proyecto.value;
    if (!search) {
      this.filterProyecto.next(this.proyectosReport.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterProyecto.next(
      this.proyectosReport.filter(cliente => cliente.nombre.toLowerCase().indexOf(search) > -1)
    );
  }
  filtraEmpleado() {
    if (!this.empleadosReportProyecto) { return; }
    let search = this.colaborador.value;
    if (!search) {
      this.filterProyectoEmpleado.next(this.empleadosReportProyecto.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterProyectoEmpleado.next(
      this.empleadosReportProyecto.filter(empleado => empleado.persona.nombreCompleto.toLowerCase().indexOf(search) > -1)
    );
  }
  limpiarFormularioReporteProyecto() {
    this.modelProyecto = '';
    this.modelClienteProyecto = '';
    this.modelColaboradorProyecto = '';
    this.idProyecto = null;
    // this.idClienteProyecto = null;
    this.idColaboladorProyecto = null;
    this.modelFechaInicioProy = null;
    this.modelFechaFinProy = null;
    this.maxDateProy = null;
    this.minDateProy = null;
    this.filtro2();
    
  }
  filtro2() {
    this.consultaPaginaReporteProyecto(1);
  }

  get totalPagesReporteProyecto(): number {
    return this.totalRegistros > 0 ? Math.ceil(this.totalRegistros / this.pageSize) : 0;
  }

  get showPaginationReporteProyecto(): boolean {
    return this.totalRegistros > 0 || (this.listaProyectoGrid?.length ?? 0) > 0;
  }

  private resolveTotalRegistros(response: any): number {
    const candidates = [
      response?.totalElements,
      response?.pTotalItems,
      response?.totalItems,
      response?.totalRegistros,
      Array.isArray(response?.content) ? response.content.length : 0,
    ];

    for (const candidate of candidates) {
      const parsed = Number(candidate);
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
      }
    }

    return 0;
  }
  
}
